<template>
    <v-card class="pa-2">
        <v-card-title class="headline px-2"
            >{{ hour ? "Update" : "Add" }} Hours</v-card-title
        >
        <div class="pa-3">
            <v-select
                class="mb-2"
                :items="getGroupNames()"
                label="Group Name"
                v-model="groupName"
                :rules="required"
                ref="groupName"
            ></v-select>
            <v-text-field
                class="mb-2"
                ref="hours"
                type="number"
                label="Hours"
                :rules="required"
                v-model="hours"
            ></v-text-field>
        </div>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn dark color="default" @click="closeDialog()">Cancel</v-btn>
            <v-btn :loading="processing" color="success" @click="save()">
                Save Hours
            </v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
import moment from "moment";
import { formatCurrency, sum } from "../../utils/helpers.js";

export default {
    props: {
        student: Object,
        reload: Function,
        closeHoursDialog: Function,
        getDomain: Function,
        hour: Object,
        groupSetups: Array,
        setup: Object,
    },
    components: {},
    data() {
        return {
            processing: false,
            groupName: "",
            hours: "",

            required: [(v) => !!v || "Required"],
        };
    },
    async created() {},
    watch: {
        hour(newValue, oldValue) {
            if (newValue) {
                this.groupName = this.getGroupName(newValue.groupID);
                this.hours = newValue.hours;
            }
        },
    },
    computed: {},
    methods: {
        closeDialog() {
            this.hours = "";
            this.groupName = "";

            this.$refs.hours.resetValidation();
            this.$refs.groupName.resetValidation();

            this.closeHoursDialog();
        },
        getGroupName(groupID) {
            if (!this.groupSetups) return "";

            return this.groupSetups.find((g) => g.groupID == groupID).groupName;
        },
        getGroupNames() {
            if (!this.groupSetups) return [];

            return this.groupSetups.map((g) => g.groupName);
        },
        getGroupID(name) {
            if (!this.groupSetups) return "";

            const setup = this.groupSetups.find((g) => g.groupName == name);

            return setup.groupID;
        },
        validate() {
            return [
                this.$refs.hours.validate(true),
                this.$refs.groupName.validate(true),
            ].every(Boolean);
        },
        async save() {
            if (!this.validate()) return;

            const isUpdating = this.hour;

            this.processing = true;

            const today = moment().format("YYYY-MM-DD HH:mm:ss");

            try {
                await this.$http.post(
                    this.getDomain() + "/api/purimStudents/saveHour",
                    {
                        groupDataID: isUpdating ? this.hour.groupDataID : 0,
                        year: this.setup.currentYear,
                        enteredOn: isUpdating
                            ? moment(this.hour.enteredOn).format(
                                  "YYYY-MM-DD HH:mm:ss"
                              )
                            : today,
                        hours: this.hours,
                        studentID: this.student.studentID,
                        groupID: this.getGroupID(this.groupName),
                        entreredBY: isUpdating
                            ? this.hour.enteredBy
                            : this.$store.state.authentication.user,
                        updatedOn: isUpdating ? today : null,
                        updatedBY: isUpdating
                            ? this.$store.state.authentication.user
                            : null,
                    }
                );

                this.processing = false;

                this.$notify({
                    text: "Hour Saved",
                    group: "notification",
                    type: "success",
                });

                this.closeDialog();

                this.reload();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
